import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { useActivate } from 'core/store/store';

import { CatalogActionType } from 'state/catalog/actions';
import { isCatalogEmptySelector } from 'state/catalog/selectors';

import { ErrorBoundary } from 'components/ErrorBoundary';

import { RoutePath } from 'RoutePath';

import { CatalogEmpty } from './CatalogEmpty';
import { CatalogList } from './CatalogList';
import { CatalogFooter } from './CatalogFooter';
import { CatalogEditDialog } from './CatalogEditDialog';
import { CatalogAddDialog } from './CatalogAddDialog';

export interface CatalogProps {
    isOnboarding: boolean;
    onFinish: () => void;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowX: 'hidden',
        width: 720,
        [theme.breakpoints.between(640, 720)]: {
            width: '100vw',
        },
        [theme.breakpoints.down(640)]: {
            width: 'auto',
        },
    },
    content: {
        flex: 1,
    },
    footer: {
        flexBasis: 'auto',
    },
}));

export const Catalog = (props: CatalogProps) => {
    useActivate(CatalogActionType.ACTIVATE, CatalogActionType.DEACTIVATE);

    const history = useHistory();
    const isCatalogEmpty = useSelector(isCatalogEmptySelector);

    const handleDialogClose = useCallback(() => {
        history.push(RoutePath.REGISTRATION_CATALOG);
    }, [history]);

    const classes = useStyles();
    return (
        <ErrorBoundary>
            <div className={classes.container}>
                <div className={classes.content}>{isCatalogEmpty ? <CatalogEmpty /> : <CatalogList />}</div>
                <footer className={classes.footer}>
                    <CatalogFooter isOnboarding={props.isOnboarding} onFinish={props.onFinish} />
                </footer>
            </div>
            <Switch>
                <Route path={RoutePath.REGISTRATION_CATALOG_EDIT}>
                    <CatalogEditDialog onClose={handleDialogClose} />
                </Route>
                <Route path={RoutePath.REGISTRATION_CATALOG_ADD}>
                    <CatalogAddDialog onClose={handleDialogClose} />
                </Route>
            </Switch>
        </ErrorBoundary>
    );
};
